import { render, staticRenderFns } from "./tenuta-di-trinoro.vue?vue&type=template&id=7b981f3c&scoped=true"
import script from "./tenuta-di-trinoro.vue?vue&type=script&lang=js"
export * from "./tenuta-di-trinoro.vue?vue&type=script&lang=js"
import style0 from "./tenuta-di-trinoro.vue?vue&type=style&index=0&id=7b981f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b981f3c",
  null
  
)

export default component.exports